import { css } from '@emotion/react';

import { EMPTY_STRING } from '../../const';
import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing } = useTheme();

  return {
    base: (isDesktop, isLoading) => css`
      height: 100%;
      display: block;
      grid-template-rows: auto 1fr;
      grid-template-columns: 100%;

      ${!isDesktop &&
      css`
        animation-name: ${isLoading ? 'slide' : EMPTY_STRING};
        animation-duration: 1s;
        animation-timing-function: ease-out;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

        @keyframes slide {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0%);
            opacity: 1;
          }
        }
      `}
    `,
    wrapper: () => css`
      ${breakpoints.m} {
        padding: 0;
      }
      ${breakpoints.l} {
        margin: 0 auto;
      }
    `,
    displayNone: css`
      display: none;
    `,
    pageView: css`
      display: block;
      grid-template-columns: 1fr 325px;
      grid-gap: 3.375rem;
      margin: 0 auto;
      max-width: 951px;
      width: 100%;
      ${breakpoints.m} {
        display: grid;
      }
      ${breakpoints.l} {
        display: grid;
      }
      @media screen and (min-width: 1281px) and (max-width: 1760px) {
        margin-left: 17.5rem;
      }
    `,
    pageViewRight: css`
      order: 2;
    `,
    pageViewLeft: css`
      @media screen and (min-width: 1601px) {
        margin-left: -2rem;
      }
    `,
    navContent: css`
      margin-top: 0.0625rem;
      padding: 0 ${spacing.m} ${spacing.m} ${spacing.m};
    `,
    contactForm: css`
      font-size: 0.875rem;
      margin-top: 10px;
      background-color: ${colors.buttonRed};
      color: ${colors.white};
      text-transform: uppercase;
      &:not(:disabled):not(:focus-visible) {
        &:hover,
        &:focus {
          background-color: ${colors.buttonBlue};
          color: ${colors.white};
        }
      }
      ${breakpoints.s} {
        &:focus-visible {
          outline: none;
          border: 2px solid ${colors.border_black};
          color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
        }
        &:focus-visible:hover {
          color: ${colors.border_black};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
        }
      }
    `,
  };
};
